export enum Challenges {
  skipMAInstallation = 'specs.programs.OOISkipMAInstallationUsers',
  hideStartDate = 'specs.challenges.OOIHideStartDateSelection',
  enableHideTeamEmail = 'specs.challenges.OOIHideSupportEmail',
  showSettingsPanel = 'specs.programs.ShowPaymentPageSettingsStudio',
  showPaymentDisplayTab = 'specs.programs.ShowPaymentPageDisplayTab',
  enableParticipantPageInEditor = 'specs.programs.EnableParticipantPage',
  redirectToParticipantPage = 'spec.programs.RedirectToParticipantPage',
  enablePremium = 'specs.programs.OOIEnablePremium',
  enableOOIStyleBP = 'specs.programs.OOIStyleBP',
  enableCustomPageInfo = 'specs.programs.EnableEditorCustomPageInfo',
  enableLinksAsBlank = 'specs.programs.OOIEnableLinksAsBlank',
  enableBidirectionalAlignment = 'specs.programs.EnableBidirectionalAlignment',
  handleCustomizedUrlSegments = 'spec.programs.HandleCustomizedUrlSegments',
  enableNewOnboarding = 'specs.programs.OOIEnableNewOnboarding',
  enableCollapsibleSidebar = 'specs.programs.OOIEnableCollapsibleSidebar',
  enableThumbnailSkinMigrationForOnlinePrograms = 'enableThumbnailSkinMigrationForOnlinePrograms',
  enableAiChat = 'specs.programs.OOIEnableAiChat',
  disableSeekOnVideo = 'specs.programs.DisableSeekOnVideo',
  aiChatEasterEgg = 'specs.programs.OOIAiChatEasterEgg',
  readPriceFromOrderService = 'specs.programs.OOIReadPriceFromOrderService',
  uniteNextAndCompleteButton = 'specs.programs.OOIUniteNextCompleteButton',
  pricingPlansV3 = 'specs.programs.ChallengesServerlessPricingPlansV3',
  enableAiVoiceChat = 'specs.programs.OOIEnableAiVoiceChat',
  enableVideoLockScreenPlayback = 'specs.programs.OOIEnableVideoLockScreenPlayback',
  OOIDisableHlsOverrideOnMobile = 'specs.programs.OOIDisableHlsOverrideOnMobile',
}
export type ExperimentsKeys = `${Challenges}`;
